import {
  FIND_BY_ID_ERROR,
  FIND_BY_ID_REQUEST,
  FIND_BY_ID_SUCCESS,
} from "./ActionType";

export const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: {},
  error: null,
  shopId: null,
  requestId: null,
};

const hasRequestMeta = (meta) =>
  meta?.shopId !== null &&
  meta?.shopId !== undefined &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const isActiveRequest = (state, meta) =>
  hasRequestMeta(meta) &&
  state.shopId === String(meta.shopId) &&
  state.requestId === meta.requestId;

const findByIDReducer = (state = initialState, action) => {
  switch (action.type) {
    case FIND_BY_ID_REQUEST: {
      if (!hasRequestMeta(action.meta)) return state;
      const shopId = String(action.meta.shopId);
      return {
        ...state,
        isRequest: true,
        isSuccess: false,
        isError: false,
        data: {},
        error: null,
        shopId,
        requestId: action.meta.requestId,
      };
    }

    case FIND_BY_ID_SUCCESS:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        error: null,
      };

    case FIND_BY_ID_ERROR:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        data: {},
        error: action.payload,
      };

    default:
      return state;
  }
};

export default findByIDReducer;
